<template>
    <div class="research_data_wrap">
        <GobackBar :stokeType="researchName"></GobackBar>
        <div :class="['research_content',wideScreen ? 'wide':'']">
            <div>
                <div class="title_tag">数据简介</div>
                <div class="brief_text">{{ brief }}</div>
            </div>
            <div>
                <div class="title_tag">字段说明</div>
                <div class="table_wrap flex-start-between">
                    <div :class="['table_menu',wideScreen? 'wide_menu' : '']">
                        <div class="table_menu_title">所有数据</div>
                        <div class="flex-between mouse-hover" @click="changeMenu(item)"
                             :class="{'activeMenu':item.id == menuId}" v-for="item in menuArr" :key="item.id">
                            <div>{{ item.title }}</div>
                            <div v-if="item.id == menuId"><i class="iconfont icon-dot"></i></div>
                        </div>
                    </div>
                    <div :class="['table_content',wideScreen? 'wide_content' : '']">
                        <el-table :data="tableArr" max-height="350" :cell-style="{textAlign:'center',padding:'5px 0px'}"
                                  stripe :header-cell-style="$core.table_header">
                            <el-table-column type="index" width="100" label="编号"></el-table-column>
                            <el-table-column prop="name" label="字段名称"></el-table-column>
                            <el-table-column prop="type" label="数据类型"></el-table-column>
                            <el-table-column prop="origin" label="数据来源"
                                             v-if="tableArr[0] && tableArr[0].hasOwnProperty('origin')"></el-table-column>
                            <el-table-column prop="percent" label="占比"
                                             v-if="tableArr[0] && tableArr[0].hasOwnProperty('percent')"></el-table-column>
                            <el-table-column width="500" prop="description" label="数据描述"></el-table-column>
                        </el-table>
                    </div>
                </div>

            </div>
            <div>
                <div class="title_tag">数据示例</div>
                <div class="img_array">
                    <div v-for="item in imgArr" :key="item.name" class="img_item">
                        <viewer>
                            <img :src="item.imgUrl" alt="">
                        </viewer>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex-around mab20">
            <el-button type="primary" @click="downloadData">下载数据</el-button>
        </div>
    </div>
</template>
<script>
import { researchMenu } from '../../utils/api';

export default {
    data() {
        return {
            researchName: this.$route.query.name,
            brief: '',
            imgArr: [],
            menuArr: [],
            tableArr: [],
            fileUrl: '',
            menuId: '',
            pageId: this.$store.state.pageId,
            wideScreen: false
        };
    },
    created() {
        if ([5, 6].includes(this.pageId)) {
            //宽屏
            this.wideScreen = true;
        }
        this.getResearchData();
    },
    methods: {
        //下载数据
        downloadData() {
            this.$confirm('此数据请通过邮箱(msdw@maxsdsp.com)联系工作人员获取', '提示', {
                confirmButtonText: '确定',
                type: 'warning'
            }).then(() => {

            });
            // location.href = this.fileUrl
        },

        //更改目录
        changeMenu(item) {
            this.menuId = item.id;
            this.tableArr = JSON.parse(item.fieldDescription);
        },

        //获取科研数据
        getResearchData() {
            researchMenu({ type: this.pageId }).then(res => {
                this.brief = res.data.description;
                this.menuArr = res.data.menus;
                this.imgArr = JSON.parse(res.data.sampleImage);
                this.menuId = res.data.menus[0].id;
                this.tableArr = JSON.parse(res.data.menus[0].fieldDescription);
                this.fileUrl = res.data.fileUrl;
            }).catch(err => {
            });
        }
    }
};
</script>
<style lang='scss' scoped>
.table_wrap {
    width: 100%;

    .table_menu {
        width: 30%;
        flex-shrink: 0;
        margin-right: 10px;
        background: white;

        .table_menu_title {
            border-bottom: 1px solid #D8D8D8;
        }

        > div {
            padding: 10px 34px;
            color: #999999;
            font-weight: 450;
            font-family: 'PingFang SC';
            font-size: 18px;
        }

        .activeMenu {
            color: #333333;
            font-weight: 600;

            i {
                color: #002D72;
            }
        }
    }

    .wide_menu {
        width: 25%;
    }

    .table_content {
        width: 68%;
    }

    .wide_content {
        width: 74%;
    }
}

.img_array {
    display: flex;
    flex-wrap: wrap;

    .img_item {
        position: relative;
        margin: 20px 20px;
        width: 250px;
        height: 180px;
        border-radius: 10px;
        box-shadow: -2px 3px 2px rgba(128, 128, 128, .4);
        overflow: hidden;

        img {
            position: absolute;
            transform: translate(-50%, -50%);
            top: 50%;
            left: 50%;
            // max-width: 250px;
            // overflow: hidden;
            // max-height: 180px;
            width: 250px;
        }
    }

    .img_item:hover {
        opacity: 0.8;
        box-shadow: -2px 3px 2px rgba(128, 128, 128, .6);
        cursor: pointer;
    }
}

.research_content {
    width: 100%;
    padding: 50px 350px;
    box-sizing: border-box;

    .title_tag {
        height: 32px;
        border-left: 8px solid #002D72;
        padding-left: 12px;
        font-weight: bold;
        font-size: 22px;
        color: #002D72;
        margin: 25px 0px;

    }

    .brief_text {
        color: #333333;
        line-height: 1.7;
        font-size: 18px;
    }
}

.wide {
    padding-left: 200px;
    padding-right: 200px;
}

.research_data_wrap {
    min-height: 100vh;
    padding-bottom: 50px;
    width: 100vw;
    background: #F7F7F7;
}
</style>
